import React, { useState, useEffect, useContext, useRef } from 'react';
import './HandlingActive.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { PerformanceContext } from '@/v2/state/providers';
import Fade from '@/v2/components/atoms/Fade';
import { StateContext } from '@/v2/state/store';
import { MomentStateContext } from '@/v2/state/momentState';

let activated = false;
let videoController = null;

const videoReady = (controller, onReady, setTime, setShowFade, state, dispatch) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());

        if (Math.round(videoController.GetTime()) === Math.round(videoController.GetEndTime() - 2)) {
            if (!state.lightBgEnabled) {
                dispatch({ type: 'SET_BACKGROUND_LIGHT' });
            }

            setShowFade(true);
        }
    });

    onReady();
};

const play = () => {
    videoController.Play();
};

const videoFinished = (onFinished) => {
    onFinished();
};

const activate = () => {
    if (activated) return;
    activated = true;
    play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [{ disclaimer }] = useContext(PerformanceContext);
    const [showFade, setShowFade] = useState(false);
    const store = useContext(StateContext);
    const { dispatch, state } = store;
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    useEffect(() => {
        activated = false;
    }, []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            activate();
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady, time.current.Set, setShowFade, state, dispatch),
        autoPlay: true,
        onFinished: () => videoFinished(onFinished),
        playbackRate: 1.3,
    };

    const headerContent = <Header show={isActive} hideLogo dark />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';
    const timeLineText = isActive ? <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" /> : '';

    return (
        <div className="HandlingActive">
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            {timeLineText}
            {disclaimerContent}
            <Fade show={showFade} slow light cover disableFadeOut />
        </div>
    );
};
